import store from "@/store";
import { CURRENCY } from "@/commons/enums";

// 各通貨に応じたマークを返す
export function getCurrencySign() {
    const selectedCurrency = store.state.currency;
    for (const currency of Object.values(CURRENCY)) {
      if (currency.language === selectedCurrency) {
        return currency.sign;
      }
    }
    return CURRENCY.JPY.language;
  }
